import React from "react";
import BatchTable from "src/pages/warehouse-management/batch";

export default function BatchPage() {
  return <BatchTable />;
}
